import { __ } from '@wordpress/i18n';
import AdminDashboard from './Dashboard';

const App = () => {
    return (
        <AdminDashboard />
    );
};

export default App;
